export const countrySelect = {
  flag_properties : 'config/r/:country/v1/property/country/active'
};
